import axios from 'axios';
import { teClient } from '@/config';

export default {
  // 貼標
  async postMemberTag(body) {
    try {
      const res = await axios.post(`${teClient}/api/v1/dynamic/mbc/post/api/v1/member-tag`, body);
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

};
